module.exports = __webpack_public_path__ + "img/17849_L.4303628d.png";